import { render, staticRenderFns } from "./SelectTypeCreateTransaction.vue?vue&type=template&id=3d9556de&"
import script from "./SelectTypeCreateTransaction.vue?vue&type=script&lang=js&"
export * from "./SelectTypeCreateTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports